import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import { MODULE_PATH } from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Control",
    meta: { requiresAuth: true },
    redirect: { name: "Map" },
    component: () => import("@/modules/Control/Control"),
    children: [
      // MAP
      {
        path: "owners",
        name: "MapOwners",
        component: () => import("@/modules/Control/Pages/ControlMapOwners"),
        meta: {
          code: MODULE.CONTROL.MAP
        },
      },
      {
        path: "map/:idOwner?",
        name: "Map",
        component: () => import("@/modules/Control/Pages/ControlMap"),
        meta: {
          code: MODULE.CONTROL.MAP
        },
      },
      // GEOFENCE
      {
        path: "geofences/list",
        name: "Geofences",
        component: () => import("@/modules/Control/Pages/GeofencesList"),
        meta: {
          code: MODULE.CONTROL.GEOFENCE
        },
      },
      {
        path: "geofences/form",
        name: "GeofenceForm",
        component: () => import("@/modules/Control/Pages/GeofenceForm"),
        meta: {
          code: MODULE.CONTROL.GEOFENCE
        },
      },
      {
        path: "geofences/visualization/:id",
        name: "GeofenceDetail",
        component: () =>
          import("@/modules/Control/Pages/GeofenceVisualization"),
        meta: {
          code: MODULE.CONTROL.GEOFENCE
        },
      },
    ],
  },
];